import { asImportReviewChrome, isReviewSessionActive } from './importReviewSession'

const STORAGE_KEY = 'abc2book.importReviewSession'

function readStoredSession() {
  if (typeof sessionStorage === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || !isReviewSessionActive(parsed)) return null
    return parsed
  } catch (e) {
    return null
  }
}

function writeStoredSession(next) {
  if (typeof sessionStorage === 'undefined') return
  try {
    if (!next || !isReviewSessionActive(next)) {
      sessionStorage.removeItem(STORAGE_KEY)
      return
    }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch (e) {}
}

let session = readStoredSession()
let uiVisible = false
const listeners = new Set()

function notify() {
  listeners.forEach(function(listener) {
    listener()
  })
}

export function registerImportReviewStarter(handler) {
  startReviewHandler = handler
}

export function requestImportReview(candidates, options) {
  if (typeof startReviewHandler === 'function') {
    startReviewHandler(candidates, options)
  }
}

let startReviewHandler = null

export function getImportReviewSession() {
  return session
}

export function isImportReviewUiVisible() {
  return uiVisible
}

export function setImportReviewSession(next) {
  // Finished / empty sessions should not linger in memory (storage already drops them).
  // Leaving them made the nav Review button stay visible with nothing to open.
  if (!next || !isReviewSessionActive(next)) {
    session = null
    uiVisible = false
    writeStoredSession(null)
    notify()
    return
  }
  session = next
  writeStoredSession(next)
  notify()
}

export function showImportReviewUi() {
  uiVisible = true
  notify()
}

/**
 * Open the review UI from the ready toast or /review route.
 * Blank "Add tunes" sessions are switched to Import review chrome so users
 * land on merge/search review instead of the add draft dialog.
 */
export function openImportReviewFromToast() {
  if (session) {
    session = asImportReviewChrome(session)
    writeStoredSession(session)
  }
  uiVisible = true
  notify()
}

export function hideImportReviewUi() {
  uiVisible = false
  notify()
}

export function clearImportReviewSession() {
  session = null
  uiVisible = false
  writeStoredSession(null)
  notify()
}

export function hasActiveImportReviewSession() {
  return isReviewSessionActive(session)
}

export function subscribeImportReviewSession(listener) {
  listeners.add(listener)
  return function unsubscribe() {
    listeners.delete(listener)
  }
}

function currentCandidateRevision(activeSession) {
  if (!activeSession || !Array.isArray(activeSession.candidates) || !activeSession.candidates.length) {
    return ''
  }
  const index = activeSession.mergeIndex != null ? activeSession.mergeIndex : activeSession.index
  const candidate = activeSession.candidates[index]
  if (!candidate) return ''
  const tune = candidate.tune || {}
  const words = Array.isArray(tune.words)
    ? tune.words.join('\n')
    : (Array.isArray(tune.wLines) ? tune.wLines.join('\n') : '')
  const inlineForm = candidate.inlineFormValues && typeof candidate.inlineFormValues === 'object'
    ? candidate.inlineFormValues
    : null
  return [
    candidate.id || '',
    String(candidate.inlineImportRevision != null ? candidate.inlineImportRevision : ''),
    candidate.sourceKind || '',
    String(tune.name || ''),
    String(tune.composer || ''),
    words,
    inlineForm ? String(inlineForm.title || '') : '',
    inlineForm ? String(inlineForm.artist || '') : '',
    inlineForm ? String(inlineForm.lyrics || '') : '',
  ].join('\x1f')
}

export function getImportReviewSessionRevision() {
  if (!session) return ''
  const jobs = session.enrichmentJobs || []
  return [
    session.step,
    session.phase,
    session.index,
    session.mergeIndex,
    session.entryMode || '',
    session.addPanelMode || 'form',
    session.forcedBook || '',
    Object.keys(session.importedCandidateIds || {}).length,
    jobs.map(function(job) {
      return job.id + ':' + job.status
    }).join(','),
    uiVisible ? '1' : '0',
    currentCandidateRevision(session),
  ].join('|')
}

export function __resetImportReviewSessionStoreForTests() {
  session = null
  uiVisible = false
  startReviewHandler = null
  listeners.clear()
  writeStoredSession(null)
}
